export const PRIMARY_NAV = [
   { title: 'Cases', path: '/' },
   { title: 'Trump Years', path: '/trump' },
   { title: 'Reps', path: '/reps' },
   { title: 'Wealthiest', path: '/wealthiest' },
   { title: 'Mega Pastors', path: '/church' },
];

export const SECONDARY_NAV = [
   { title: 'Submit', path: '/submit' },
   { title: 'Support', path: '/support' },
   { title: 'About', path: '/about' },
];

export interface HeroCopy {
   kicker: string;
   title: string;
   blurb?: string;
   size?: 'xl' | 'md';
}

export const HERO_COPY: Record<string, HeroCopy> = {
   '/': {
      kicker: 'Case archive',
      title: 'The record does not forget.',
      blurb: "Keeping track of the world's major corporate and government misconduct.",
      size: 'xl',
   },
   '/reps': {
      kicker: 'U.S. Congress',
      title: 'Those who represent you.',
      blurb: 'Every sitting member, the bills they sponsor, and the record they leave behind.',
      size: 'xl',
   },
   '/wealthiest': {
      kicker: 'Concentrated power',
      title: "The world's wealthiest.",
      blurb: 'The fortunes, the companies behind them, and the influence they buy.',
      size: 'xl',
   },
   '/church': {
      kicker: 'Faith & fortune',
      title: 'Mega pastors.',
      blurb: 'The richest men of the pulpit, and how their ministries made them so.',
      size: 'xl',
   },
   '/about': { kicker: 'About', title: 'Why we keep the record.', size: 'md' },
   '/support': { kicker: 'Support', title: 'Keep the lights on.', size: 'md' },
   '/submit': { kicker: 'Submit a case', title: 'Tell us what is missing.', size: 'md' },
};
